import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateOrganizationStripeCustomerProps, LoadOrganizationStripeBillingProps, ReduxOrganizationStripeBillingAddEditState } from '../types';
import { ISelectItem, ReduxSliceState } from '../../../shared/types';
import { withPayloadType } from '../../../shared/utils';
import { ReduxRootState } from '../../../shared/redux/store';
import { OrganizationStripeBilling } from '../../../api/types';

const initialState: ReduxOrganizationStripeBillingAddEditState = {
    state: 'BUSY',
    organizationstripebilling: undefined,
};

export const loadOrganizationStripeBilling = createAction('organizationstripebilling/add-edit/loadOrganizationStripeBilling', withPayloadType<LoadOrganizationStripeBillingProps>());
export const createOrganizationStripeCustomer = createAction('organizationstripebilling/add-edit/createOrganizationStripeCustomer', withPayloadType<CreateOrganizationStripeCustomerProps>());


const organizationStripeBillingAddEditSlice = createSlice({
    name: 'organizationstripebilling/add-edit',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setOrganizationStripeBilling: (state, action: PayloadAction<OrganizationStripeBilling | undefined>) => {
            state.organizationstripebilling = action.payload;
        },
    }
});

export default organizationStripeBillingAddEditSlice;

const selectSelf = (state: ReduxRootState) => state.organizationStripeBillingAddEdit;

export const selectOrganizationStripeBillingAddEditState = createSelector(selectSelf, self => self.state);
export const selectOrganizationStripeBillingAddEditIsBusy = createSelector(selectOrganizationStripeBillingAddEditState, state => state === 'BUSY');
export const selectOrganizationStripeBilling = createSelector(selectSelf, self => self.organizationstripebilling);
export const selectOrgStripeBillingCustomerId = createSelector(selectSelf, self => self.organizationstripebilling?.customerId);
export const selectOrgStripeBillingPaymentMethodId = createSelector(selectSelf, self => self.organizationstripebilling?.paymentMethodId);
